import React from 'react';
import Slider, { Settings } from 'react-slick';
import Tab from '../UI/Slider/Tab';
import Arrow from '../UI/Slider/Arrow';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export const gameSelectionSliderConfig = () : any =>{
  return {
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    centerMode: true,
    speed: 100,
    adaptiveHeight: true,
    infinite: true,
    edgeFriction: 0.1,
    variableWidth: false,
    transformEnabled: false,
    slidesToShow: 1,
    initialSlide: 0,
  }
};

export const getShowcaseSliderConfig = (title:string[]): Settings => {
  let slideChanges = 0;
  const timeout = 7000;
  return {
    dots: true,
    autoplay: true,
    autoplaySpeed: timeout,
    speed: 500,
    arrows: true,
    pauseOnHover: false,
    beforeChange: (currentSlide: number, nextSlide: number) => {slideChanges = nextSlide },
    appendDots: dots=> <ul>{dots}</ul>,
    customPaging: i => <Tab title={i} gameTitle={title[i]} currentSlide={slideChanges} timeout={timeout}/>,
    nextArrow: <Arrow direction="right" color="#428ee0"  />,
    prevArrow: <Arrow direction="left" color="#428ee0" />
  };
};